import React from "react";
import { string, number, oneOfType } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";

import DefaultMobileLogo from "../../../../assets/images/palo-bangla.svg";
import KishoraloLogo from "../../../../assets/images/kishoralo.svg";
import BigganChintaLogo from "../../../../assets/images/biggan-chinta.svg";
import EnglishHeaderLogo from "../../../../assets/images/palo-english.svg";
import NagorikLogo from "../../../../assets/images/nagorik.svg";
import { headerLevelLogo, getCurrentSite } from "../../utils/utils";
import TrustLogo from "../../../../assets/images/trust-logo.svg";
import naLogo from "../../../../assets/images/Na_logo.svg";
import Icon from "../../icons";

import "./mobileLogo.m.css";

const MobileLogo = ({ domainSlug, lang, pageType, currentPath }) => {
  const HeaderTag = `h${headerLevelLogo(pageType)}`;

  const renderLogo = () => {
    if (domainSlug === "kishoralo" || getCurrentSite(currentPath) === "kishoralo") {
      return <img src={`${assetify(KishoraloLogo)}`} styleName="kishoralo-logo" alt="কিশোর আলো" />;
    } else if (domainSlug === "bondhushava" || getCurrentSite(currentPath) === "bondhushava") {
      return <Icon iconStyle={{ width: "132px", height: "36px" }} type="bondhushava" className="bondhushava" />;
    } else if (domainSlug === "protichinta" || getCurrentSite(currentPath) === "protichinta") {
      return <Icon iconStyle={{ width: "113px", height: "36px" }} type="protichinta" className="protichinta" />;
    } else if (
      domainSlug === "biggan-chinta" ||
      getCurrentSite(currentPath) === "biggan-chinta" ||
      domainSlug === "bigganchinta" ||
      getCurrentSite(currentPath) === "bigganchinta"
    ) {
      return <img src={`${assetify(BigganChintaLogo)}`} alt="বিজ্ঞান চিন্তা" styleName="biggan-chinta-logo" />;
    } else if (domainSlug === "trust" || getCurrentSite(currentPath) === "trust") {
      return <img src={`${assetify(TrustLogo)}`} alt="প্রথম আলো ট্রাস্ট" styleName="trust-logo" />;
    } else if (domainSlug === "nagorik-sangbad" || getCurrentSite(currentPath) === "nagorik-sangbad") {
      <img src={`${assetify(NagorikLogo)}`} alt="নাগরিক সংবাদ" styleName="nagorik-logo" />;
    } else if (
      domainSlug === "northamerica" ||
      domainSlug === "na" ||
      getCurrentSite(currentPath) === "northamerica" ||
      getCurrentSite(currentPath) === "na"
    ) {
      return (
        <img src={`${assetify(naLogo)}`} alt="উত্তর আমেরিকা" styleName="na-logo" className="desktop-na-logo na-logo" />
      );
    } else if (lang === "en" || getCurrentSite(currentPath) === "en") {
      return <img src={`${assetify(EnglishHeaderLogo)}`} alt="Prothom alo" styleName="palo-english-logo" />;
    } else {
      return <img src={`${assetify(DefaultMobileLogo)}`} alt="প্রথম আলো" styleName="palo-logo" />;
    }
  };
  return <HeaderTag className="mobile-logo">{renderLogo()}</HeaderTag>;
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", ""], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
});

MobileLogo.propTypes = {
  domainSlug: string,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  color: string,
  lang: string,
  pageType: string,
  currentPath: string,
};

export default connect(mapStateToProps)(MobileLogo);
